import { parseJwt } from "../jwt/jwt_decode";
import autobahn from "autobahn";
import magentaOauth from "@/lib/auth-ts/magentaOAuth";

export default {
  decodeToken() {
    const jwt = localStorage.getItem("ACCESS_TOKEN");
    // Decode JWT
    const jwtDecodeResult = parseJwt(jwt);
    return jwtDecodeResult;
  },

  establishWsConnection(
    url,
    realm,
    authmethods,
    authid,
    { customOnOpen, customOnClose }
  ) {
    let args = {
      url: url,
      realm: realm,
      authmethods: authmethods,
      authid: authid,
      max_retries: 10,
      max_retry_delay: 150,
      initial_retry_delay: 1,
      retry_delay_growth: 1.3,
      retry_delay_jitter: 0.1,
      on_user_error: function(error, customErrorMessage) {
        console.error("Error de usuario:", error, customErrorMessage);
      },
      on_internal_error: function(error) {
        console.error("Error interno:", error);
      },
      onchallenge: onchallenge
    };
    function onchallenge(session, method, extra) {
      if (method === "oauth2") {
        const jwt = localStorage.getItem("ACCESS_TOKEN");
        if (jwt) {
          return jwt;
        } else {
          return new Promise(async (resolve, reject) => {
            let willRetry = true
            for (let i = 0; i < 3 && willRetry; i++) {
              try {
                const res = await magentaOAuth.refreshToken()
                if (res.status === 200) {
                  const { access_token: accessToken } = res.data;
                  resolve(accessToken)
                  willRetry = false
                  window.location.reload()
                } else if (res.status >= 400 && res.status < 500) {
                  localStorage.clear()
                  window.location.replace(`${window.location.origin}/portal/login`)
                  willRetry = false
                } else {
                  willRetry = true
                }
              } catch (err) {
                localStorage.clear()
                willRetry = false
                console.error("No access token available for challenge.")
                reject(err)
              }
            }
          })
        }
      } else {
        throw "don't know how to authenticate using '" + authmethods + "'";
      }
    }
    const connection = new autobahn.Connection(args);
    connection.onopen = customOnOpen;
    connection.onclose = customOnClose;
    connection.open();
    return connection;
  },
  //Create connection but it doesn't open it
  createWSConnection(url, realm, authmethods, authid) {
    let args = {
      url: url,
      realm: realm,
      authmethods: authmethods,
      authid: authid,
      onchallenge: onchallenge
    };
    function onchallenge(session, method, extra) {
      if (method === "oauth2") {
        const jwt = localStorage.getItem("ACCESS_TOKEN");
        return jwt;
      } else throw "don't know how to authenticate using '" + authmethods + "'";
    }
    const connection = new autobahn.Connection(args);
    return connection;
  },
  createkwArgs() {
    // Decode JWT
    const jwtDecodeResult = this.decodeToken();
    let kwArgs = {
      security: {
        realm_uri: jwtDecodeResult.aud, //opcional
        session: jwtDecodeResult.id, //opcional
        client_id: jwtDecodeResult.iss,
        username: jwtDecodeResult.sub,
        authid: jwtDecodeResult.sub,
        groups: jwtDecodeResult.groups,
        locale: jwtDecodeResult.language || "es_AR",
        meta: jwtDecodeResult.meta
      }
    };
    return kwArgs;
  },
  getUserId() {
    const data = this.decodeToken();
    return data.meta.user_id;
  },
  getBusinessUserId() {
    const data = this.decodeToken();
    return data.meta.business_user_id;
  },
  getAccountId() {
    const data = this.decodeToken();
    return data.meta.business_account_id;
  },
  getAuthId() {
    const data = this.decodeToken();
    return data.sub;
  },
  getGroups() {
    const data = this.decodeToken();
    return data.groups;
  }
};
